import { Stagger, Item } from "@/components/motion/Reveal";

export const StatsStrip = ({ stats = [] }) => {
  if (!stats.length) return null;
  return (
    <section data-testid="stats-strip" className="border-y border-white/10 bg-surface/40">
      <Stagger className="wrap grid grid-cols-2 lg:grid-cols-4 lg:divide-x lg:divide-white/10" gap={0.1}>
        {stats.map((s, i) => (
          <Item key={i} className="px-2 py-10 sm:py-14 lg:px-10">
            <p className="font-display text-5xl font-extrabold tracking-[-0.04em] sm:text-6xl" data-testid={`stat-value-${i}`}>{s.value}</p>
            <p className="eyebrow mt-3">{s.label}</p>
          </Item>
        ))}
      </Stagger>
    </section>
  );
};
